export enum MultiplePaymentTypeEnum {
  SALE_CONSIDERATION_INC_GST = 1,
  SALE_CONSIDERATION_SEPARATE_GST = 2,
  SALE_CONSIDERATION = 3,
  GST = 4
}
export type MultiplePaymentType = {
  [key in MultiplePaymentTypeEnum]: string;
};

export const MULTIPLE_PAYMENT_TYPE_LIST: MultiplePaymentType = {
  [MultiplePaymentTypeEnum.SALE_CONSIDERATION_INC_GST]:
    'Sale Consideration Incl. GST',
  [MultiplePaymentTypeEnum.SALE_CONSIDERATION_SEPARATE_GST]:
    'Sale Consideration with separate GST',
  [MultiplePaymentTypeEnum.SALE_CONSIDERATION]:
    'Sale Consideration(Pay GST Later)',
  [MultiplePaymentTypeEnum.GST]: 'Pay GST'
};
